import { Controller } from "@hotwired/stimulus";

// Keeps the "direct booking" and "price on request" booking-configuration
// toggles consistent in the product sku form: a price-on-request product can
// only be enquired, so direct booking is force-unchecked and disabled while
// the flag is on. The authoritative enforcement lives in the model
// (ProductSkuBookingConfiguration); this is only the immediate UI feedback.
export default class extends Controller {
  static targets = ["priceOnRequest", "directBooking"];

  connect() {
    this.sync();
  }

  sync() {
    const on = this.priceOnRequestTarget.checked;

    if (on) {
      this.directBookingTarget.checked = false;
    }

    this.directBookingTarget.disabled = on;
  }
}
